import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { GenericLoadingOverlay } from 'src/consumer/components/helperComponents'
import { getBookingRequestsForMentor } from 'src/consumer/services/featureServices'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { deleteBookingRequest } from 'src/mentor/reducers/bookingRequest/bookingRequestReducer'
import { PageMainContentContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { StyledEventsRefreshIcon } from '../MentorEventsPage/MentorEventsPageStyles'
import { BookingRequestStripForMentor, CloseButtonForBack } from './MentorBookingRequestComponents'
import { useNavigate } from 'react-router-dom'

export default function MentorBookingRequestAllPage() {
  const [dataLoading, setDataLoading] = useState(false)
  const [requestsData, setRequestsData] = useState([])
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const tooltipComp = (
    <Tooltip id="tooltip">
      <strong>Update Therapy Booking Requests</strong>
    </Tooltip>
  )

  async function getAndSetVisibleBookingRequests() {
    setDataLoading(true)
    let response = await getBookingRequestsForMentor(
      dayjs()?.utc()?.subtract(24, 'hours')?.format('YYYY-MM-DDTHH:mm:ss[Z]'),
      true,
    )
    setDataLoading(false)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      setRequestsData(response?.data?.data?.bookingRequests)
    }
  }

  useEffect(() => {
    getAndSetVisibleBookingRequests()
  }, [])

  const removeBookingRequestFromStoreById = (bookingReqId) => {
    dispatch(deleteBookingRequest(bookingReqId))
  }

  console.log(requestsData)

  return (
    <PageMainContentContainer style={{ marginTop: '100px', padding: '20px' }}>
      <div style={{ marginBottom: '32px' }}>
        <CloseButtonForBack />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            <b>Therapy Booking Requests</b>
          </div>
          <div style={{ fontSize: '12px' }}>
            (where start time of session is after{' '}
            {dayjs()?.subtract(24, 'hours')?.format('DD-MM-YYYY h:mm A')})
          </div>
        </div>
        {dataLoading ? (
          <Spinner animation="border" variant="dark" size="sm" />
        ) : (
          <OverlayTrigger placement="bottom" overlay={tooltipComp}>
            <StyledEventsRefreshIcon onClick={getAndSetVisibleBookingRequests} />
          </OverlayTrigger>
        )}
      </div>
      <div style={{ marginBottom: '32px', cursor: 'pointer' }}>
        or{' '}
        <span onClick={() => navigate('/mentor-home/my-calendar?view=booked')}>
          <u>Check your existing bookings</u>
        </span>
      </div>
      <div style={{ position: 'relative', width: '100%', minHeight: '50px' }}>
        {dataLoading && (
          <GenericLoadingOverlay
            backgroundColor={'rgba(78, 8, 122, 0.15)'}
            spinnerVariant={'dark'}
          />
        )}
        {requestsData?.length > 0 ? (
          requestsData?.map((item, index) => {
            return (
              <BookingRequestStripForMentor
                key={index}
                data={item}
                afterAcceptOrRejectFunc={() => {
                  removeBookingRequestFromStoreById(item?.id)
                  getAndSetVisibleBookingRequests()
                }}
              />
            )
          })
        ) : (
          <div>No requests</div>
        )}
      </div>
    </PageMainContentContainer>
  )
}
